<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()">
        <n-button>Создать запись</n-button>
      </n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td>
            Дата бетонирования<br />
            <div style="white-space: nowrap;">
              от
              <n-input inline style="width:160px" />
              <br />
            </div>
            <div style="white-space: nowrap;">
              до
              <n-input inline style="width:160px" />
            </div>
          </td>
          <td>
            Наименование бетонируемой части сооружении и конструктивных элементов. Эскиз бетонируемой части сооружения
            с отметками в начале и в конце смены
          </td>
          <td>Класс бетона по прочности на сжатие</td>
          <td>Состав бетонной смеси и водоцементное отношение, № карточки подбора состава бетона</td>
          <td>Вид и активность цемента</td>
          <td>Подвижность бетонной смеси</td>
          <td>Температура смеси при укладке</td>
          <td></td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td></td>
        </tr>
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)">
          <n-button icon="eye" />
        </n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load"
                        @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load"
                  @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_spec2_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'concretingDate', title: '', },
        { name: 'title', title: '', },
        { name: 'concreteClass', title: '', },
        { name: 'compound', title: '', },
        { name: 'concreteType', title: '', },
        { name: 'mobility', title: '', },
        { name: 'temperature', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'Spec2')
        .query({})
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
